import { render } from "./EmailModal.vue?vue&type=template&id=b0ddad50&scoped=true&ts=true"
import script from "./EmailModal.vue?vue&type=script&lang=ts"
export * from "./EmailModal.vue?vue&type=script&lang=ts"

import "./EmailModal.vue?vue&type=style&index=0&id=b0ddad50&scoped=true&lang=scss"
import "./EmailModal.vue?vue&type=style&index=1&id=b0ddad50&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ddad50"]])

export default __exports__